import React, { useState } from "react";

import {
  PortalMsal as Portal,
  IconLlaveInglesa,
  Link,
  AppContainer,
  IconBuscar,
  IconEstrella,
  MessageSplash,
} from "@portal/arq-portal-core";
import { AlertasButton, MiEscritorio } from "@portal/arq-portal-alertas";
import { Favoritos } from "@portal/arq-portal-favoritos";
import { Buscador, BuscadorTextField } from "@portal/arq-portal-buscador";
import { Marquesina } from "@portal/arq-portal-marquesinas";
import { Productos } from "@portal/arq-portal-productos";
import { BuzonesList, BuzonesButton } from "@portal/arq-portal-buzones";
import { AsesoresFinancieros } from "@portal/arq-portal-asesores-financieros";

import { IconButton, makeStyles } from "@material-ui/core";

import { SoporteComponent } from "@portal/arq-portal-soporte";
import { DescargaComponent } from "@portal/arq-portal-paginadescarga";
import { InfoUsuario } from "@portal/arq-portal-usuariosinfo";

import Home from "./HomeHeading";
import Admin from "./Admin";
import { App365Container } from "@portal/arq-portal-core";
import { InfoMenu } from "./InfoMenu";
import { InformesAutos } from "@portal/arq-portal-informes-autos";
import { Chatbot, ChatbotGepetto, Chatbotv2 } from "@portal/arq-portal-chatbot";
import {
  VisorEnlaces,
  FormacionOperaciones,
} from "@portal/arq-portal-visor-enlaces";
import { Organigrama } from "@portal/arq-portal-organigrama";
import { MuroCompleto } from "@portal/arq-portal-gestiona-muro";
import { AdmBloqueadosMicrostrategy } from "@portal/arq-portal-admmicrostrategy";

const useStyles = makeStyles((theme: any) => ({
  containerToolBarIcon: {
    borderLeft: "1px solid",
    borderRight: "1px solid",
    height: "100%",
    display: "inline-block",
    "& .MuiIconButton-root:hover": {
      background: "transparent",
    },
    "& .MuiIconButton-root": {
      borderRadius: "0%",
    },
    "& .MuiTouchRipple-root": {
      display: "none",
    },
    "& .MuiButtonBase-root": {
      paddingRight: "12px",
      paddingLeft: "12px",
      height: "100%",
    },
    "& .MuiButtonBase-root:first-child": {
      borderRadius: "0px",
      paddingRight: "8px",
      "@media screen and (max-width: 1200px)": {
        paddingRight: "5px",
      },
      "&::before": {
        content: '" "',
        borderRight: "1px solid #fff",
        position: "absolute",
        right: "0px",
        height: "calc(100% + 10px)",
        top: "-9px",
      },
    },
  },
  toolbarIcon: {
    color: theme.palette.primary.contrastText,
    padding: "3px",
  },
  mensajeIcon: {
    color: "#fff",
    padding: "3px 12px 3px 10px",
  },
  popoverBusquedaContainer: {
    "& ": {
      zIndex: "1099 !important" as any,
      top: "58px !important",
    },
    "& > div:first-child": {
      backgroundColor: "rgba(96, 96, 96, 0.376) !important",
    },
    "& .MuiPopover-paper": {
      marginTop: "-15px",
      marginLeft: "-10px",
      boxShadow: "none",
      borderRadius: "0px",
    },
  },
  iconBuscar: {
    "& .MuiSvgIcon-root": {
      marginTop: "10px",
      marginLeft: "1px",
    },
    "@media screen and (max-width: 1200px)": {
      padding: "0px",
    },
  },
}));

function PortalApp(props: any) {
  const classes = useStyles(props);
  // const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  // const open = Boolean(anchorEl);

  // const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  const routes = [
    {
      path: "/buscar/:valor",
      titulo: "Buscar",
      component: <Buscador></Buscador>,
      exact: true,
    },
    {
      path: "/favoritos",
      titulo: "Favoritos",
      component: <Favoritos onEnlaceClick={() => {}}></Favoritos>,
      exact: true,
    },
    {
      path: "/utilidades/soporte",
      titulo: "Soporte",
      component: (
        <React.Fragment>
          <SoporteComponent></SoporteComponent>
          <Chatbot idBot={"INCIDENCIAS"}></Chatbot>
        </React.Fragment>
      ),
      exact: true,
    },
    {
      path: "/empleados/inventariodeformacion",
      titulo: "Inventario Formación",
      component: (
        <AppContainer
          menuOption={{
            tipo: "APLICACIONESSCO",
            urlApp: "FE/PER.RRHH.Formacion.FE.Kprl/",
            titulo: "Inventario Formación",
            plantilla: "GCOAPP",
          }}
        />
      ),
    },
    {
      path: "/negocio/recibosycuentadelmediador/descargadeficheros",
      titulo: "Descarga de ficheros",
      component: <DescargaComponent></DescargaComponent>,
      exact: true,
    },
    {
      path: "/negocio/recibosycuentamediador/descargadeficheros",
      titulo: "Descarga de ficheros",
      component: <DescargaComponent></DescargaComponent>,
      exact: true,
    },
    {
      path: "/negocio/recibosycuentadelmediador/descargascuentamediador",
      titulo: "Descarga cuenta mediador",
      component: <DescargaComponent></DescargaComponent>,
      exact: true,
    },
    {
      path: "/gestionadministrativa/gestiondeagencia/descargasspu/descargadeficherosspu",
      titulo: "Descarga de ficheros",
      component: <DescargaComponent></DescargaComponent>,
      exact: true,
    },
    {
      path: "/productossco",
      titulo: "Productos SCO",
      component: <Productos cia="SCO" />,
      exact: true,
    },
    {
      path: "/productossbi",
      titulo: "Productos SB",
      component: <Productos cia="SBI" />,
      exact: true,
    },
    {
      path: "/productosspu",
      titulo: "Productos PU",
      component: <Productos cia="SPU" />,
      exact: true,
    },
    {
      path: "/_usuario/:dominio/:usuario",
      titulo: "Informacion Usuarios",
      component: <InfoUsuario />,
      exact: false,
      admin: true,
    },
    {
      path: "/_usuario",
      titulo: "Informacion Usuarios",
      component: <InfoUsuario />,
      exact: true,
    },
    {
      path: "/buzones",
      titulo: "Listado de buzones",
      component: <BuzonesList />,
      exact: true,
    },
    {
      path: "/_admin",
      titulo: "Administración del portal",
      component: <Admin />,
      exact: true,
      admin: true,
    },
    {
      path: "/_admin/meinteresa",
      titulo: "Configuración me interesa",
      component: (
        <App365Container
          menuOption={{
            tipo: "GCOAPP365",
            urlApp: "ARQ.Portal.Homes.FE.ConfiguracionMeInteresa/",
            titulo: "Configuración me interesa",
            plantilla: "GCOAPP",
          }}
        ></App365Container>
      ),
      exact: true,
      admin: true,
    },
    {
      path: "/_admin/marquesinas",
      titulo: "Configuración marquesinas",
      component: (
        <App365Container
          menuOption={{
            tipo: "GCOAPP365",
            urlApp: "ARQ.Portal.Homes.FE.ConfiguracionMarquesinas/",
            titulo: "Configuración marquesinas",
            plantilla: "GCOAPP",
          }}
        ></App365Container>
      ),
      exact: true,
      admin: true,
    },
    {
      path: "/_admin/resultadosfinancieros",
      titulo: "Configuración resulados financieros",
      component: (
        <App365Container
          menuOption={{
            tipo: "GCOAPP365",
            urlApp: "ARQ.Portal.Homes.FE.ResultadosFinancieros/",
            titulo: "Configuración resultados financieros",
            plantilla: "GCOAPP",
          }}
        ></App365Container>
      ),
      exact: true,
      admin: true,
    },
    {
      path: "/_admin/enlaces",
      titulo: "Administración de enlaces",
      component: (
        <App365Container
          menuOption={{
            tipo: "GCOAPP365",
            urlApp: "ARQ.Portal.Admin.FE.ListadoEnlaces/",
            titulo: "Administración de enlaces",
            plantilla: "GCOAPP",
          }}
        ></App365Container>
      ),
      exact: true,
      admin: true,
    },
    {
      path: "/_admin/audiencias",
      titulo: "Administración de audiencias",
      component: (
        <App365Container
          menuOption={{
            tipo: "GCOAPP365",
            urlApp: "ARQ.Portal.Admin.FE.ListaAudiencias/",
            titulo: "Administración de audiencias",
            plantilla: "GCOAPP",
          }}
        ></App365Container>
      ),
      exact: true,
      admin: true,
    },
    {
      path: "/_admin/roles",
      titulo: "Administración de roles",
      component: <App365Container menuOption={{tipo: "GCOAPP365", urlApp: "ARQ.Portal.Admin.FE.ListaRoles/", titulo: "Administración de roles", plantilla:"GCOAPP"}}></App365Container>,
      exact: true,
      admin: true
    },
    {
      path: "/_admin/componentes",
      titulo: "Administración de componentes",
      component: (
        <App365Container
          menuOption={{
            tipo: "GCOAPP365",
            urlApp: "ARQ.Portal.Admin.FE.ListaComponentes/",
            titulo: "Administración de componentes",
            plantilla: "GCOAPP",
          }}
        ></App365Container>
      ),
      exact: true,
      admin: true,
    },
    {
      path: "/_admin/configpuntomenu",
      titulo: "Administración de configuración de puntos de menu",
      component: (
        <App365Container
          menuOption={{
            tipo: "GCOAPP365",
            urlApp: "ARQ.Portal.Menu.FE.BusquedaMenu/",
            titulo: "Administración de componentes",
            plantilla: "GCOAPP",
          }}
        ></App365Container>
      ),
      exact: true,
      admin: true,
    },
    {
      path: "/_admin/puntosbloqueadosmicrostrategy",
      titulo: "Administración de puntos bloqueados Microstrategy",
      component: <AdmBloqueadosMicrostrategy></AdmBloqueadosMicrostrategy>,
      exact: true,
      admin: true,
    },
    {
      path: "/_admin/suscripciondescargaficheros",
      titulo: "Administración suscripción descarga ficheros",
      component: (
        <App365Container
          menuOption={{
            tipo: "GCOAPP365",
            urlApp: "ARQ.Portal.Admin.FE.SuscripcionDescargaFicheros/",
            titulo: "Administración suscripción descarga ficheros",
            plantilla: "GCOAPP",
          }}
        ></App365Container>
      ),
      exact: true,
      admin: true,
    },
    {
      path: "/simularusuario",
      titulo: "Simular usuario",
      component: (
        <AppContainer
          menuOption={{
            tipo: "AplicacionesSCO",
            urlApp: "FE/TPG.Seguridad.Web.FE.Tssu/",
            titulo: "Simular usuario",
            plantilla: "GCOAPP",
          }}
        ></AppContainer>
      ),
      exact: true,
    },
    {
      path: "/_info",
      titulo: "Información del punto de menú",
      component: <InfoMenu></InfoMenu>,
      admin: true,
    },
    {
      path: "/utilidades/asesorfinancierosco",
      titulo: "Asesor Financiero",
      component: (
        <AsesoresFinancieros menuOption="/utilidades/asesorfinancierosco" />
      ),
    },
    {
      path: "/utilidades/asesorfinancierosbi",
      titulo: "Asesor Financiero",
      component: (
        <AsesoresFinancieros menuOption="/utilidades/asesorfinancierosbi" />
      ),
    },
    {
      path: "/utilidades/asesorsaludsco",
      titulo: "Asesor salud",
      component: (
        <AsesoresFinancieros menuOption="/utilidades/asesorsaludsco" />
      ),
    },
    {
      path: "/utilidades/asesorsaludsbi",
      titulo: "Asesor salud",
      component: (
        <AsesoresFinancieros menuOption="/utilidades/asesorsaludsbi" />
      ),
    },
    {
      path: "/PrepersaNET/reportesmicrostrategy",
      titulo: "Reportes Microstrategy",
      component: <InformesAutos></InformesAutos>,
    },
    {
      path: "/biblioteca/abogados/links",
      titulo: "Enlaces de interés",
      component: (
        <VisorEnlaces
          IdComponente={"links-PRE0101011"}
          titulo="Enlaces de interés"
        ></VisorEnlaces>
      ),
    },
    {
      path: "/portales/portalformacion/operaciones",
      titulo: "Operaciones",
      component: <FormacionOperaciones></FormacionOperaciones>,
    },
    {
      path: "/organigrama",
      titulo: "Organigrama",
      component: <Organigrama></Organigrama>,
    },
    {
      path:"/botRRHH",
      titulo: "Test Bot RRHH",
      component: <Chatbot idBot={"RRHH"} isFullScreen={"true"}/>
    },
    {
      path:"/botIT",
      titulo: "Test Bot IT",
      component: <Chatbot idBot={"IT"} isFullScreen={"true"}/>
    },
    {
      path:"/botMediadores",
      titulo: "Test Bot Mediadores",
      component: <Chatbot idBot={"Agente"} isFullScreen={"true"}/>
    },
    {
      path:"/botGenerico",
      titulo: "Test Bot Generico",
      component: <Chatbot idBot={"GENERICO"} isFullScreen={"true"}/>
    },
    {
      path:"/botIncidencias",
      titulo: "Test Bot Incidencias",
      component: <Chatbot idBot={"INCIDENCIAS"} isFullScreen={"true"}/>
    },
    {
      path:"/botVidaFiscal",
      titulo: "Test Bot Vida-Fiscal",
      component: <Chatbot idBot={"VIDAFISCAL"} isFullScreen={"true"}/>
    },
    {
      path:"/botLegalCorporativo",
      titulo: "Test Bot Legal Corporativo",
      component: <Chatbot idBot={"LEGALCORPORATIVA"} isFullScreen={"true"}/>
    },
    {
      path:"/botContactCenter",
      titulo: "Test Bot Contact Center",
      component: <Chatbot idBot={"CONTACTCENTER"} isFullScreen={"true"}/>
    },
    {
      path:"/botResponsabilidadCivil",
      titulo: "Test Bot Responsabilidad Civil",
      component: <Chatbot idBot={"RESPONSABILIDADCIVIL"} isFullScreen={"true"}/>
    },
    {
      path:"/botMultirriesgo",
      titulo: "Test Bot Multiriesgo",
      component: <Chatbot idBot={"MULTIRRIESGO"} isFullScreen={"true"}/>
    },
    {
      path:"/botAutos",
      titulo: "Test Bot Autos",
      component: <Chatbot idBot={"AUTOS"} isFullScreen={"true"}/>
    },{
      path:"/botVida",
      titulo: "Test Bot Vida",
      component: <Chatbot idBot={"VIDA"} isFullScreen={"true"}/>
    },{
      path:"/botCRM",
      titulo: "Test Bot CRM",
      component: <Chatbot idBot={"CRM"} isFullScreen={"true"}/>
    },{
      path:"/botPrepersa",
      titulo: "Test Bot Prepersa",
      component: <Chatbot idBot={"PREPERSA"} isFullScreen={"true"}/>
    },{
      path:"/botReaseguro",
      titulo: "Test Bot Reaseguro",
      component: <Chatbot idBot={"REASEGURO"} isFullScreen={"true"}/>
    },{
      path:"/botCSO",
      titulo: "Test Bot CSO",
      component: <Chatbot idBot={"CSO"} isFullScreen={"true"}/>
    },{
      path:"/botOrganizacion",
      titulo: "Test Bot Organizacion",
      component: <Chatbot idBot={"ORGANIZACION"} isFullScreen={"true"}/>
    },{
      path:"/botSiniestrosDiversos",
      titulo: "Test Bot Siniestros Diversos",
      component: <Chatbot idBot={"SINIESTROSDIVERSOS"} isFullScreen={"true"}/>
    },{
      path:"/botGestiona",
      titulo: "Test Bot Gestiona",
      component: <Chatbot idBot={"GESTIONA"} isFullScreen={"true"}/>
    },
    {
      path:"/botComunicacion",
      titulo: "Test Bot Comunicación",
      component: <Chatbot idBot={"COMUNICACION"} isFullScreen={"true"}/>
    },
    {
      path: "/foro",
      titulo: "Foro",
      component: <MuroCompleto />,
    },
    {
      path:"/botv2Dev",
      titulo: "Botv2 - Desarrollo",
      component: <Chatbotv2 url="https://app-an-lab-dev.azurewebsites.net/"/>
    },
    {
      path:"/botv2Prod",
      titulo: "Botv2 - Produccion",
      component: <Chatbotv2 url="https://app-an-lab-prod.azurewebsites.net/"/>
    },
    {
      path:"/gepetto",
      titulo: "Geppeto de incidencias",
      component: <ChatbotGepetto/>
    }
  ];

  let componentesReact = {
    admin: <Admin />,
    infomenu: <InfoMenu />,
    infousuario: <InfoUsuario />,
    buscar: <Buscador />,
    favoritos: <Favoritos />,
    buzones: <BuzonesList />,
    productos: <Productos />,
    soporte: (
      <React.Fragment>
        <SoporteComponent />
        {/* <Chatbot idBot={"INCIDENCIAS"} /> */}
      </React.Fragment>
    ),
    bot: <Chatbot/>,
    asesoresfinancieros: <AsesoresFinancieros />,
    organigrama: <Organigrama />,
    informeautos: <InformesAutos />,
    visorenlaces: <VisorEnlaces />,
    formacionoperaciones: <FormacionOperaciones />,
    descargaficheros: <DescargaComponent />,
    alertas: <MiEscritorio />,
    botv2: <Chatbotv2/>,
    mensaje: <MessageSplash/>,
    gepetto: <ChatbotGepetto/>
  };

  const [refreshMarquesina, setRefreshMarquesina] = useState<boolean>(false);
  const manejarCierreMarquesina = (id: string) => {
    console.log("refrescando");
    localStorage.setItem("MarquesinaId", id);
    setRefreshMarquesina(true);
  };

  const showOnMarquesinaOnlyIcon = (idMarquesina: string) => {
    console.log("idMarquesina", idMarquesina);
    return (
      idMarquesina && localStorage.getItem("MarquesinaId") === idMarquesina
    );
  };

  /*
  const firebaseConfig: FirebaseConfig =
    window.location.hostname.startsWith("d") ||
    window.location.hostname.startsWith("w")
      ? {
          options: {
            apiKey: "AIzaSyAA_QrLBy-LCs4Qa1GGihxEoXzfEEf03JE",
            authDomain: "gestiona-dev.firebaseapp.com",
            projectId: "gestiona-dev",
            storageBucket: "gestiona-dev.appspot.com",
            messagingSenderId: "892155993442",
            appId: "1:892155993442:web:1decb03b01022fa3d5603b",
            measurementId: "G-W2WX0N3C4E",
            vapidKey:
              "BFQ1jpLCsul9LLh5SLLs1bSnxzVe8EPfecLv_2sipvF_3a-CbbKDqRP2Q-_5_wDSrDMsPRJC6Ebgr42sJFf4kYg",
          },
          push: { app: "GEST", cia: "GCO" },
        }
      : {
          options: {
            apiKey: "AIzaSyA6Mo9JmKm1I599V4iwivVHSLlucNDnt6Q",
            authDomain: "gestiona-pro.firebaseapp.com",
            projectId: "gestiona-pro",
            storageBucket: "gestiona-pro.appspot.com",
            messagingSenderId: "732487751455",
            appId: "1:732487751455:web:0218582d54df975283022a",
            measurementId: "G-EYDGJWRNLG",
            vapidKey:
              "BD43AElVDUtzLBeoZ3ejVfwb9fPvrXu4fn0RdHr-6BH0Fn6uRqdXTnZudo84eNYJstcVBG8txgn-ffjBm8C5lJA",
          },
          push: { app: "GEST", cia: "GCO" },
        };
        */

  return (
    <Portal
      title="Gestiona"
      cia="GCO"
      menuSvc="/usermenu/"
      noExpandirMenu={true}
      routes={routes}
      componentesReact={componentesReact}
      //firebase={firebaseConfig}
      favs={{
        favsSvc: "/be/favs",
        favsAddSvc: "/be/favsadd",
        favsDelSvc: "/be/favsdel",
      }}
      historial={{ guardarSvc: "/be/historialguardar" }}
      acciones={[
        {
          icon: (
            <span className={classes.iconBuscar}>
              {" "}
              <IconBuscar />
            </span>
          ),
          body: (
            <BuscadorTextField
              style={{ margin: "10px 20px", width: "600px" }}
            ></BuscadorTextField>
          ),
          classNameBody: classes.popoverBusquedaContainer,
          id: "buscador",
        },
        {
          icon: <IconEstrella style={{ width: 20 }} />,
          body: <Favoritos></Favoritos>,
        },
      ]}
      accionesUsuario={
        <React.Fragment>
          <IconButton component={Link} to="/utilidades/soporte" size="small">
            <IconLlaveInglesa style={{ color: "white" }}></IconLlaveInglesa>
          </IconButton>
          <AlertasButton className={classes.toolbarIcon}></AlertasButton>
          <BuzonesButton></BuzonesButton>
        </React.Fragment>
      }
      marquesina={
        refreshMarquesina ? (
          <Marquesina
            disposable={false}
            showOnMarquesinaOnlyIcon={showOnMarquesinaOnlyIcon}
          />
        ) : (
          <Marquesina
            disposable={false}
            showOnMarquesinaOnlyIcon={showOnMarquesinaOnlyIcon}
          />
        )
      }
      buscadorTextField={<BuscadorTextField></BuscadorTextField>}
      globalBot={<Chatbot idBot="GESTIONA"></Chatbot>}
    >
      <Home manejarCierreMarquesina={manejarCierreMarquesina} />
    </Portal>
  );
}

export default PortalApp;
